<template>
    <!-- 点击其他地方关闭 -->
    <div @click.stop="showPopOutP($event)">
        <!-- 结构树 -->
        <vue-okr-tree
            :default-expanded-keys="defaultexpandedkeys"
            node-key="unique_id"
            :direction="direction"
            :key="defaultexpandedkeys.length || defaultExpandAll || direction"
            :data="data2"
            show-collapsable
            :default-expand-all="defaultExpandAll"
            :render-content="renderContent"
        />
    </div>
</template>
<script>
// 详情弹框
import popover from './popover.vue';
export default {
    name: '',
    components: {
        popover
    },
    // data2数据
    // short简版
    // direction横向竖向
    props: ['data2', 'short', 'direction'],
    data() {
        return {
            defaultexpandedkeys: [],
            defaultExpandAll: true,
            showData: {},
            isPopShowP: false
        };
    },

    mounted() {},
    methods: {
        // 通过 render-content 渲染节点内容。
        renderContent(h, node) {
            if (node.data.persons_enable) {
                return (
                    <div class="dsf">
                        <div
                            class="relative"
                            style={
                                'width:' +
                                (this.short == true && node.childNodes.length <= 0
                                    ? '190px'
                                    : this.short == true || node.childNodes.length <= 0
                                    ? '190px'
                                    : node.data.is_group_node == 1
                                    ? '190px'
                                    : '190px') +
                                ''
                            }
                        >
                            {/*详情弹框*/}
                            <div on-click={(event) => this.showPop(node.data, event)}>
                                <popover
                                    showData={this.showData}
                                    ref="popover"
                                    style={
                                        'visibility:' +
                                        (this.showData.unique_id && this.showData.unique_id == node.data.unique_id ? 'visible' : 'hidden') +
                                        ''
                                    }
                                ></popover>
                            </div>
                            {/*点击...显示详情*/}
                            <div
                                style={'top:' + (node.data.department_role == 1 ? '26px' : '6px') + ''}
                                class="clickBtn"
                                on-click={(event) => this.showPop(node.data, event)}
                            >
                                <span style={'display:' + (node.data.is_group_node == 1 ? 'none' : 'flex') + ''}>...</span>
                            </div>
                            {/*颜色区分department_role == 1*/}
                            <div
                                class={{
                                    department_role: true,
                                    style0: node.data.department.A_rank_department_rid == '', // 根节点
                                    style1: node.data.department.A_rank_department_rid == 'DPMT0000000015', // 技术
                                    style2: node.data.department.A_rank_department_rid == 'DPMT0000000002', // 运营
                                    style3: node.data.department.A_rank_department_rid == 'DPMT0000000025', // 生产
                                    style4: node.data.department.A_rank_department_rid == 'DPMT0000000039' // 营销
                                }}
                                style={'display:' + (node.data.department_role == 1 ? 'flex' : 'none') + ''}
                            >
                                <div style="width:100%; overflow: hidden;white-space: nowrap;font-size:12px;text-overflow: ellipsis !important;">
                                    {node.data.department_label}
                                </div>
                            </div>
                            {/*颜色区分department_role ！= 1*/}
                            <div
                                class={{
                                    department_role_line: true,
                                    style0: node.data.department.A_rank_department_rid == '', // 根节点
                                    style1: node.data.department.A_rank_department_rid == 'DPMT0000000015', // 技术
                                    style2: node.data.department.A_rank_department_rid == 'DPMT0000000002', // 运营
                                    style3: node.data.department.A_rank_department_rid == 'DPMT0000000025', // 生产
                                    style4: node.data.department.A_rank_department_rid == 'DPMT0000000039' // 营销
                                }}
                                style={'display:' + (node.data.department_role != 1 ? 'flex' : 'none') + ''}
                            ></div>

                            <div
                                class={{
                                    cardMain: true,
                                    style00: node.data.department.A_rank_department_rid == '', // 根节点
                                    style11: node.data.department.A_rank_department_rid == 'DPMT0000000015', // 技术
                                    style22: node.data.department.A_rank_department_rid == 'DPMT0000000002', // 运营
                                    style33: node.data.department.A_rank_department_rid == 'DPMT0000000025', // 生产
                                    style44: node.data.department.A_rank_department_rid == 'DPMT0000000039' // 营销
                                }}
                            >
                                {/*虚拟职位*/}
                                <div style={'display:' + (node.data.is_group_node == 1 ? 'flex' : 'none') + ''} class="cardInfo">
                                    <div style="color: gray;overflow: hidden;white-space: nowrap;text-overflow: ellipsis !important;font-size:12px;">
                                        {node.data.label || node.data.department_label}
                                    </div>
                                </div>

                                {/*非虚拟职位，暂无人员*/}
                                <div
                                    style={
                                        'display:' +
                                        (node.data.persons_enable.length == 0 ? (node.data.is_group_node == 1 ? 'none' : 'flex') : 'none') +
                                        ''
                                    }
                                    class="cardInfo"
                                >
                                    <img
                                        src="http://img.chenpon.com/default.svg"
                                        class="headImg"
                                        style={'display:' + (this.short ? 'none' : 'block') + ''}
                                    />
                                    <div style={'margin-left:' + (this.short ? '0px' : '8px') + ''}>
                                        <div style="width:80px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis !important;font-size:10px;">
                                            待招
                                        </div>
                                        <div class="mobileSty">{node.data.label}</div>
                                    </div>
                                </div>

                                <div style={'display:' + (node.data.persons_enable.length == 0 ? 'none' : 'flex') + ''} class="cardInfo">
                                    {/*接口照片数据*/}
                                    <img
                                        src={
                                            node.data.persons_enable.length > 0 && node.data.persons_enable[0].picture
                                                ? node.data.persons_enable[0].picture
                                                : 'http://img.chenpon.com/default.svg'
                                        }
                                        style={'display:' + (this.short ? 'none' : 'block') + ''}
                                        class="headImg"
                                    />
                                    <div style={'margin-left:' + (this.short ? '0px' : '8px') + ''}>
                                        <div
                                            style="width:80px; overflow: hidden;white-space: nowrap;text-overflow: ellipsis !important;font-size:13px;"
                                            on-click={() => this.toDetail(node.data, 'person')}
                                        >
                                            {node.data.persons_enable.length > 0
                                                ? node.data.persons_enable[0].concentration == 1
                                                    ? node.data.persons_enable[0].label
                                                    : node.data.persons_enable[0].label + '*'
                                                : ''}
                                        </div>
                                        <div class="mobileSty" on-click={() => this.toDetail(node.data, 'hierarchy')}>
                                            {node.data.label}
                                        </div>
                                    </div>
                                </div>

                                <div style="text-align: center;margin-right: 10px;padding-bottom: 10px;display: flex;justify-content: flex-end;position: absolute;bottom: -5px;right: -5px;font-size:8px;">
                                    {/*接口人数数据*/}
                                    <div
                                        class="cardMantime"
                                        style={
                                            'display:' + (node.childNodes.length <= 0 && node.data.sum_staffing <= 0 ? 'none' : 'flex') + ''
                                        }
                                    >
                                        {node.data.sum_staffing}
                                        <span
                                            style={
                                                'display:' + (node.data.sum_staffing > node.data.number_without_temp ? 'flex' : 'none') + ''
                                            }
                                        >
                                            /{node.data.sum_staffing - node.data.number_without_temp}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        },
        showPop(data, event) {
            this.$set(this, 'showData', data);
            event.stopPropagation();
        },
        showPopOutP(e) {
            this.showData = {};
        },
        expandAllFalse() {
            this.defaultexpandedkeys.splice(0, this.defaultexpandedkeys.length);

            this.$set(this, 'defaultExpandAll', false);
        },
        toDetail(data, type) {
            if (type == 'hierarchy' && data.rid) {
                this.$router.push({
                    path: '/hierarchyDetail',
                    query: {
                        id: data.rid
                    }
                });
            } else if (type == 'person' && data.persons_enable.length > 0) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: data.persons_enable[0]['pivot']['person_rid']
                    }
                });
            }
        },
        expandAllTrue() {
            this.defaultexpandedkeys.splice(0, this.defaultexpandedkeys.length);
            this.$set(this, 'defaultExpandAll', true);
        }
    }
};
</script>
<style>
.showPopBox {
    position: absolute;
    top: 0px;
    left: 226px;
    visibility: hidden;
    z-index: 1000000;
}
.clickBtn {
    position: absolute;
    right: 9px;
    font-weight: bold;
    z-index: 1000;
    color: gainsboro;
    display: none;
}
.relative {
    position: relative;
    border-radius: 5px 5px 5px 5px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    /*background: white;*/
}
.content-box {
    /*background: transparent;*/
}
.relative:hover .clickBtn {
    display: block;
}
.org-chart-node-label-inner {
    /* width: 250px !important; */
    padding: 0 !important;
    position: relative;
}
.cardHeader {
    width: 100%;
    height: 30px;
    background-color: aqua;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.cardMain {
    padding: 5px;
    font-size: 15px;
    /* display: flex;
    align-items: center;
    justify-content: center; */
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis !important;
    position: relative;
    border-radius: 0 0 5px 5px;
    /*box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);*/
}

.style0 {
    background: hsl(120, 30%, 60%);
}

.style1 {
    background: hsl(0, 30%, 60%);
}

.style2 {
    background: hsl(120, 30%, 60%);
}

.style3 {
    background: hsl(190, 30%, 60%);
}

.style4 {
    background: hsl(240, 30%, 60%);
}

.style00 {
    background: hsl(120, 30%, 90%);
}

.style11 {
    background: hsl(0, 30%, 90%);
}

.style22 {
    background: hsl(120, 30%, 90%);
}

.style33 {
    background: hsl(190, 30%, 90%);
}

.style44 {
    background: hsl(240, 30%, 90%);
}
.el-popover .item {
    position: relative;
    width: 100%;
    padding-bottom: 15px;
}

.el-popover .item .face {
    display: block;
    max-width: 50px;
    max-height: 60px;
    margin: 4px 0;
}

.el-popover .item .name {
    width: 180px;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
}

.el-popover .item .tel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
}

.el-popover .item .tel i {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    margin-right: 6px;
}

.department_role {
    height: 18px;
    color: #fff;
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-size: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis !important;
    border-radius: 5px 5px 0 0;
}
.popItem {
    width: 70%;
    margin-top: 10px;
}
.popItem label {
    width: 30%;
    display: inline-block;
}
.department_role_line {
    height: 5px;
    border-radius: 5px 5px 0 0;
}

.headImg {
    height: 60px;
    width: 45px;
    margin-left: 0px;
    margin-top: -5px;
    border-radius: 3px;
}

.cardMantime {
    color: gray;
    font-size: 8px;
}

.cardInfo {
    margin-top: 10px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
}

.vertical .org-chart-node:after,
.vertical .org-chart-node:before:nth-last-child(1) {
    display: none;
}

.vertical .org-chart-node-children {
    display: flex;
}
.mobileSty {
    margin-top: 5px;
    font-size: 11px;
    color: gray;
}
</style>
